function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "#020000"
}, /*#__PURE__*/React.createElement("rect", {
  x: 0.0083808,
  y: 0.0084666,
  width: 8.4583,
  height: 1.0851,
  strokeWidth: 0.30074
}), /*#__PURE__*/React.createElement("rect", {
  x: 0.0083808,
  y: 7.3815,
  width: 4.2181,
  height: 1.0851,
  strokeWidth: 0.21238
}), /*#__PURE__*/React.createElement("rect", {
  x: 0.0083808,
  y: 3.6908,
  width: 4.2181,
  height: 1.0851,
  strokeWidth: 0.21238
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(.36138 -.24092)",
  fill: "#020000"
}, /*#__PURE__*/React.createElement("rect", {
  x: 5.2019,
  y: 2.6157,
  width: 0.99867,
  height: 4.4491,
  strokeWidth: 0.13645
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 5.2104,
  cy: 7.2414,
  rx: 0.99973,
  ry: 0.97889,
  strokeWidth: 0.22267
}), /*#__PURE__*/React.createElement("path", {
  d: "m5.2847 2.9359c-0.12725-0.14622-0.011643-0.37158 0.14637-0.43986 0.23577-0.11825 0.071302-0.24934 0.32201-0.28337 0.25692-0.066664 0.86955 0.45512 1.0308 0.63897 0.24445 0.30585 0.47184 0.63209 0.78001 0.879 0.22542 0.2067 0.47774 0.44902 0.49065 0.77552-0.00292 0.28882-0.28086 0.49887-0.54988 0.52916-0.21358 0.033112-0.47775-0.017114-0.59298-0.21874-0.081852-0.19504 0.066564-0.3774 0.12219-0.55566 0.079848-0.23781-0.075251-0.47528-0.24636-0.62751-0.21062-0.18056-0.47208-0.28874-0.73059-0.38103-0.25694-0.082533-0.54375-0.11908-0.75642-0.29847z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m5.681 2.2062c-0.26533 0.00812-0.47585 0.20982-0.47575 0.45579-7.68e-5 0.00465-7.68e-5 0.0093 0 0.013953h0.98329c2.628e-4 -0.00465 4.487e-4 -0.0093 5.577e-4 -0.013953-2.39e-5 -0.14371-0.07182-0.27188-0.18399-0.35542-0.08429-0.062777-0.19138-0.10035-0.30794-0.10036-0.00539-8.21e-5 -0.010783-8.21e-5 -0.016174 0z"
}));

function SvgSongs(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 8.4667 8.4667",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSongs);
export default __webpack_public_path__ + "static/media/songs.f88f1c4b.svg";
export { ForwardRef as ReactComponent };